export const MAIL_PWA_INSTALL_DISMISS_KEY = "mail_pwa_install_dismissed";
export const MAIL_PWA_PERMS_DISMISS_KEY = "mail_pwa_perms_dismissed";
export const MAIL_PWA_PERMS_DONE_KEY = "mail_pwa_perms_done_v1";

export function isMobilePwaAudience(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  if (/iphone|ipad|ipod|android/i.test(ua)) return true;
  const macTouch = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  if (macTouch) return true;
  try {
    return window.matchMedia("(max-width: 900px)").matches;
  } catch {
    return false;
  }
}

export function readSessionFlag(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function writeSessionFlag(key: string): void {
  try {
    sessionStorage.setItem(key, "1");
  } catch {
    /* ignore */
  }
}

export function readLocalFlag(key: string): boolean {
  try {
    return localStorage.getItem(key) === "1";
  } catch {
    return false;
  }
}

export function writeLocalFlag(key: string): void {
  try {
    localStorage.setItem(key, "1");
  } catch {
    /* ignore */
  }
}
